import { styled } from '@clickcease/cc-client-components-lib'

export const TrialEndedModalStyled = styled('div', {
  width: '450px',
  padding: '12px 24px 18px 24px',
})

export const TrialEndedModalSubtitle = styled('div', {
  fontSize: '$md',
  marginBottom: '$10',
  height: '120px',
})
export const TrialEndedModalCurrentProduct = styled('span', {
  margin: '0 $2',
})

export const TrialEndedModalContinueUsing = styled('div', {
  marginTop: '$6',
})
